/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import { usePathname } from 'next/navigation';
import { WhoCanDoV5St } from '../Common/CompLangConfig';

/* Services */
/* Config */

/**
 * @param {Object} sectionContent - Data
 * @param {string} lang - Language of the page
 * @returns
 */

const styles = {
  contentText: {
    p: {
      padding: '4px 0',
      fontFamily: 'FedraSansStd-book',
      fontStyle: 'italic',
      a: {
        color: '#F37021',
        textDecoration: 'underline',
      },
    },
  },
  descContent: {
    p: {
      padding: '4px 0',
      fontFamily: 'FedraSansStd-book',
      fontStyle: 'normal',
      textAlign: 'center',
      a: {
        color: '#F37021',
        textDecoration: 'underline',
      },
    },
  },
};

const WhoCanDoIYP = ({ sectionContent, lang }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const path = usePathname();
  const under25Url = path.includes('under-25s');
  useEffect(() => {
    const urls = sectionContent
      .filter(item => item._modelApiKey === 'single_image')
      .map(item => item);
    setImageUrls(urls);
  }, [sectionContent]);

  const urlData = [
    `Open to everyone, regardless of one's background or beliefs`,
    'No specific physical flexibility or agility required',
    'No prior experience or knowledge of Yoga is necessary',
  ];
  const urlDataTa = [
    `இப்பயிற்சியில் கலந்துகொள்ள வாழ்க்கை முறை மற்றும் பழக்க வழக்கங்களில் எந்தவித மாற்றமும் கொண்டுவர தேவையில்லை`,
    'குறிப்பிட்ட உடல் நெகிழ்வுத்தன்மை அல்லது துரிதம் தேவையில்லை',
    'யோகாவில் முன்அனுபவம் எதுவும் தேவையில்லை.',
  ];

  //console.log('==', sectionContent);
  return (
    <Box
      bg={
        under25Url
          ? 'url(https://static.sadhguru.org/d/46272/1710743888-1710584276-pbg1.jpg) repeat'
          : '#F1EBDF'
      }
      maxW={'100%'}
      py={8}
      px={{ base: 4, md: 8 }}
    >
      <Box maxW={'1031px'} mx={'auto'}>
        <Text
          mt={{ base: '2.5rem', md: '4rem' }}
          mb={{ base: '1.5rem', md: '3rem' }}
          color={'#433F3C'}
          fontFamily={'FedraSansStd-medium'}
          fontSize={{ base: '24px', sm: '30px', md: '64px' }}
          lineHeight={{ base: '28px', md: '64px' }}
          fontWeight={'500'}
        >
          {sectionContent[0].text}
        </Text>
        <Grid
          gap={{ base: 4, md: 8 }}
          templateColumns={{ base: '1fr', md: '1fr 1fr' }}
        >
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <Box maxW="100%" maxH="100%">
              <Box
                bgImage={{
                  base: sectionContent[1]?.mobileImage.url,
                  md: sectionContent[1]?.image?.url,
                }}
                width={{ base: '280px', md: '100%' }}
                height={{ base: '250px', md: '470px' }}
                display="flex"
                alignItems="flex-end"
                bgSize="cover"
                bgPos="top center"
                p={{ base: '15px', md: '30px 40px' }}
                mx="auto"
              >
                <Text
                  py={{ base: 4, sm: 2, md: 2 }}
                  color={'#FF9840'}
                  fontFamily={'FedraSansStd-medium'}
                  fontSize={{ base: '14px', md: '24px' }}
                  lineHeight={{ base: '18px', md: '33.6px' }}
                  fontWeight={'500'}
                >
                  {sectionContent[5].text}
                </Text>
              </Box>
            </Box>
          </GridItem>
          {sectionContent.slice(2, 4)?.map((url, index) => (
            <GridItem key={index} colSpan={{ base: 1, md: 1 }}>
              <Box
                bgImage={{
                  base: url?.mobileImage?.url,
                  md: url?.image?.url,
                }}
                width={{ base: '280px', md: '100%' }}
                height={{ base: '250px', md: '470px' }}
                display="flex"
                alignItems="flex-end"
                bgSize="cover"
                bgPos="top center"
                p={{ base: '5px 15px', md: '30px 40px' }}
                mx="auto"
              >
                <Text
                  bottom={{ base: 3, sm: 3, lg: 12 }}
                  left={{ base: 4, sm: 6, lg: 10 }}
                  py={{ base: 4, sm: 2, md: 2 }}
                  color={'#FF9840'}
                  fontFamily={'FedraSansStd-medium'}
                  fontSize={{ base: '14px', md: '24px' }}
                  lineHeight={{ base: '18px', md: '33.6px' }}
                  fontWeight={'500'}
                >
                  {sectionContent[6 + index].text}
                </Text>
              </Box>
            </GridItem>
          ))}
        </Grid>
      </Box>
      <Box
        maxW={'1031px'}
        mx={'auto'}
        textAlign={'center'}
        mt={{ base: '1.5rem', md: '3rem' }}
        mb={{ base: '1rem', md: '2rem' }}
      >
        <StructuredTextParser
          str={render(sectionContent[4]?.body)}
          color="#000"
          textAlign={{
            base: 'left',
            md: 'center',
          }}
          fontSize={{ base: '16px', md: '22px' }}
          fontWeight="400"
          mx="auto"
          sx={lang === 'ta' ? styles.descContent : styles.contentText} // Apply the styles here
          {...WhoCanDoV5St[lang]}
        />
      </Box>
    </Box>
  );
};

export default WhoCanDoIYP;
